<template>
    <div class="main-content auth__page d-md-block">
        <!-- Header -->
        <!-- <Header /> -->
      
        <!-- Page content -->
        <div class="row align-items-center">
            <div class="auth__page--right col-md-6 d-none d-md-block d-md-flex">
                <div class="mb-4">
                  
                <div class="centered-img"><img src="/img/log.png" alt="Login" width="400" height="400">
                </div>
                <!-- <div class="centered"> 
                    <p class="text-white"> Vous avez déjà un compte sur Medsurlink?</p>
                    <p :class="isDisabled?  'text-danger': 'text-white'" >Connectez-vous pour créer une alerte.</p>
                    <button class="btn btn-outline-white px-3 mt-4" @click="effectFunction"> Créer  une alerte</button>
                </div> -->
                    <div class="copyright text-center d-flex">
                        <div>
                            <div class="mb-4 text-light">
                                &copy; {{year}} <a href="https://www.medicasure.com" class="ml-1 text-light"
                                            target="_blank"> {{ $t('message.copyright_internal_footer') }}</a>
                                <!-- <ul class="nav nav-footer mt-2">
                                    <li class="nav-item">
                                        <a href="https://www.medicasure.com" class="nav-link" target="_blank">Medicasure</a>
                                        
                                    </li>
                                    <span> | </span>
                                    <li class="nav-item">
                                        <a href="https://www.medicasure.com/#" class="nav-link" target="_blank">A Propos
                                        </a>
                                    </li>
                                    <span> | </span>
                                    <li class="nav-item">
                                        <a href="https://www.medicasure.com/#" class="nav-link" target="_blank">Blog</a>
                                    </li>
                                </ul> -->
                            </div>
                        </div>
                        
                                <!-- <ul class="nav text-white">
                                    <li><i class="fa fa-facebook" aria-hidden="true"></i></li>
                                    <li><i class="fa fa-instagram" aria-hidden="true"></i></li>
                                    <li><i class="fa fa-twitter" aria-hidden="true"></i></li>
                                    <li><i class="fa fa-linkedin" aria-hidden="true"></i></li>
                                </ul> -->
                    </div>
                </div>
            </div>

            <div :class="isDisabled? 'col-md-6 p-0 p-md-5 pt-2 effect':'col-md-6 p-0 p-md-5 pt-5'">
                <div class="text-center w-50 m-auto text-white">
                    <img src="../../public/img/brand/logo-white.png" alt="" class="img-fluid w-75 d-md-none mb-4">
                    <img src="../../public/img/brand/favicon/logo.png" alt="" class="img-fluid w-75 d-none d-md-block ml-5">
                </div>
                <slide-y-up-transition mode="out-in" origin="center top">
                    <router-view></router-view>
                </slide-y-up-transition>
                    <div class="mx-3 d-md-none">
                    <ul class="list-none p-0 notification-card-content mt-3 mb-3"></ul>
                    <div class="text-center pt-3 mb-4 b_alert">
                        <p :class="isDisabled?  'text-danger': 'text-white p-text'" >Connectez-vous pour créer une alerte.</p>
                        <button class="btn btn-outline-white px-3 mt-2 w-100 p-text" @click="effectFunction"> Créer  une alerte</button> 
                    </div>
                </div>
            </div>
            <div class="log-footer py-3 mt-2 col-md-6 d-md-none">
                <div class="text-center d-md-none justify-content-center ">
                    <div class="text-center justify-content-center px-2">
                        &copy; {{year}} <a href="https://www.medicasure.com" class="font-weight-bold ml-1 foo_alert px-2"
                                target="_blank"> {{ $t('message.copyright_internal_footer') }}</a>
                    </div>
                    <!-- <ul class="nav nav-footer justify-content-center text-white">
                        <li class="nav-item">
                            <a href="https://www.medicasure.com" class="nav-link" target="_blank">Medicasure</a>
                            
                        </li>
                        <span> | </span>
                        <li class="nav-item">
                            <a href="https://www.medicasure.com/#" class="nav-link" target="_blank">A Propos
                            </a>
                        </li>
                        <span> | </span>
                        <li class="nav-item">
                            <a href="https://www.medicasure.com/#" class="nav-link" target="_blank">Blog</a>
                        </li>
                    </ul> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Header from '@/components/Header.vue'
  import { SlideYUpTransition } from 'vue2-transitions';
  import AppConfig from '../constants/AppConfig';

  export default {
    name: 'auth-layout',
    components: {
      SlideYUpTransition,
      Header
    },
    data() {
      return {
        effect: true,
        isDisabled: false,
        logo: AppConfig.baseUrl + '/img/brand/logo-blanc.png',
        year: new Date().getFullYear(),
        showMenu: false
      }
    },
    methods:{
        effectFunction: function () {
            var v = this;
            v.isDisabled = true;
            localStorage.setItem('ancestor_link', 'alertes');
            setTimeout(function () {
                v.isDisabled = false;
            }, 1000);
        }
    },
    mounted() {
        if(this.$route.query.name != null){
            localStorage.setItem('ancestor_link', this.$route.query.name);
        }
    }
  }
</script>
<style lang="scss">
   
</style>
